/**
 * Drive do cliente: contrato social, cartão CNPJ, alvará, certidões, procurações, comprovantes… em pastas livres que o
 * escritório cria. Publicado, o arquivo aparece no portal em "Arquivos da empresa", separado dos documentos das tarefas.
 */
import { z } from 'zod';
import { Id } from './comum.js';

export const PASTAS_PADRAO = ['Documentos da empresa', 'Certidões e licenças', 'Contratos e procurações', 'Comprovantes', 'Fiscal e contábil'] as const;

export const DrivePasta = z.object({ id: Id, nome: z.string(), ordem: z.number().int(), arquivos: z.number().int(), publicados: z.number().int() });
export type DrivePasta = z.infer<typeof DrivePasta>;
export const DriveItem = z.object({
  id: Id, pastaId: Id, pastaNome: z.string(), titulo: z.string(), nome: z.string(), mime: z.string(), tamanho: z.number().int(), visivelCliente: z.boolean(), enviadoPorApelido: z.string().nullable(), criadoEm: z.string(),
});
export type DriveItem = z.infer<typeof DriveItem>;
export const DriveResposta = z.object({ pastas: z.array(DrivePasta), arquivos: z.array(DriveItem) });
export type DriveResposta = z.infer<typeof DriveResposta>;
export const DrivePastaBody = z.object({ nome: z.string().trim().min(1).max(80), ordem: z.number().int().min(0).max(9999).optional() });
export type DrivePastaBody = z.infer<typeof DrivePastaBody>;
export const DriveEditarBody = z.object({ pastaId: Id.optional(), titulo: z.string().trim().min(1).max(120).optional(), visivelCliente: z.boolean().optional() });
export type DriveEditarBody = z.infer<typeof DriveEditarBody>;
